import * as BABYLON from "@babylonjs/core";

export const HAZUKI_EXTERIOR_PREFIX = "S1_JHD0";
export const HAZUKI_INTERIOR_PREFIX = "S1_JOMO";
export const YAMANOSE_PREFIX = "S1_JU00";
export const SAKURAGAOKA_PREFIX = "S1_JD00";
export const DOBUITA_PREFIX = "S1_D000";
export const NEW_YOKOSUKA_HARBOR_PREFIX = "S2_MFSY";
export const OLD_WAREHOUSE_DISTRICT_PREFIX = "S2_MKSG";
export const OLD_WAREHOUSE_EIGHT_PREFIX = "S2_MS08";
export const FORKLIFT_RACE_PREFIX = "S3_MA00";
export const YOU_ARCADE_PREFIX = "S3_DGCT";

export const HAZUKI_SPAWN = new BABYLON.Vector3(-6.48, 0, -19.32);
export const HAZUKI_INTERIOR_SPAWN = new BABYLON.Vector3(-15.28, 0, 1.04);
export const YAMANOSE_SPAWN = new BABYLON.Vector3(
  51.98007583618164,
  7.74480676651001,
  99.62751007080078,
);
export const YAMANOSE_ENTRY_YAW = -2 * Math.PI / 3;
export const SAKURAGAOKA_SPAWN = new BABYLON.Vector3(-8, 0, 21);
export const DOBUITA_SPAWN = new BABYLON.Vector3(
  67.79,
  0,
  61.92,
);
export const NEW_YOKOSUKA_HARBOR_SPAWN = new BABYLON.Vector3(53, 0, 42);
export const OLD_WAREHOUSE_DISTRICT_SPAWN = new BABYLON.Vector3(60, 0, -9);
export const FORKLIFT_PLAYGROUND_SPAWN = new BABYLON.Vector3(1.6, 0, 29);
export const FORKLIFT_RACE_PLAYER_SPAWN = new BABYLON.Vector3(48, 0, 105);
export const VOID_RESET_HEIGHT = -10;
